<script setup lang="ts">
import { computed } from 'vue';

interface UiDividerProps {
  width?: 'full' | 'auto' | string;
  color?: 'default' | 'light' | 'dark';
  thickness?: 'thin' | 'normal' | 'thick';
  spacing?: 'none' | 'xs' | 'sm' | 'md' | 'lg';
}

const props = withDefaults(defineProps<UiDividerProps>(), {
  width: 'full',
  color: 'default',
  thickness: 'normal',
  spacing: 'md',
});

const dividerClasses = computed(() => {
  let classes = 'border-t';

  // Width classes
  switch (props.width) {
    case 'full':
      classes += ' w-full';
      break;
    case 'auto':
      classes += ' w-auto';
      break;
    default:
      classes += ` ${props.width}`;
  }

  // Color classes
  switch (props.color) {
    case 'light':
      classes += ' border-gray-200';
      break;
    case 'dark':
      classes += ' border-gray-400';
      break;
    default:
      classes += ' border-gray-300';
  }

  // Thickness classes
  switch (props.thickness) {
    case 'thin':
      classes += ' border-t';
      break;
    case 'thick':
      classes += ' border-t-2';
      break;
    default:
      break;
  }

  // Spacing classes
  switch (props.spacing) {
    case 'none':
      break;
    case 'xs':
      classes += ' my-1';
      break;
    case 'sm':
      classes += ' my-2';
      break;
    case 'lg':
      classes += ' my-6';
      break;
    default:
      classes += ' my-4';
  }

  return classes;
});
</script>

<template>
  <hr :class="dividerClasses" />
</template>

